export default "body {\n  background-color: aliceblue;\n  height: 100%;\n  .my-card {\n    height: 300px;\n    width: 300px;\n  }\n}";